<template>
  <wrapper>
    <template slot="header-actions">
      <div class="btn-group">
        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" :disabled="isExporting">
          {{  isExporting ? 'Exporting' : 'Export Data' }}
          <i v-if="isExporting" class="fa fa-spin fa-spinner ml-2"></i>
          <span v-else class="caret ml-2"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a href="#" @click.prevent="getSchoolsCSV">Schools CSV</a></li>
          <li><a href="#" @click.prevent="getReadersCSV">Readers CSV</a></li>
        </ul>
      </div>
    </template>
  <div class="challenges-report-page">
    <div class="dashbox-strip">
      <div class="dashbox-cell">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Schools Registered" :value="totalOrgs.total" :active_value="totalOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalOrgs.total.toLocaleString('en')}}</strong> schools have registered, <i class="fa fa-bolt"></i> <strong>{{ totalOrgs.active.toLocaleString('en') }}</strong> have at least 1 child who has read something.</div>
        </flip-card>
      </div>
      <div class="dashbox-cell">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Parents Registered" :value="totalUsers.total" :active_value="totalUsers.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalUsers.total.toLocaleString('en')}}</strong> parents have registered, <i class="fa fa-bolt"></i> <strong>{{ totalUsers.active.toLocaleString('en') }}</strong> have at least 1 child who has read something.</div>
        </flip-card>
      </div>
      <div class="dashbox-cell">
        <flip-card id="db-readers-registered">
          <dash-box slot="front" title="Readers Registered" :value="totalReaders.total" :active_value="totalReaders.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalReaders.total.toLocaleString('en')}}</strong> children are in the challenge, <i class="fa fa-bolt"></i> <strong>{{ totalReaders.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
      <div class="dashbox-cell">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Readers Associated to a School" :value="readersInOrgs.total" :active_value="readersInOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{readersInOrgs.total.toLocaleString('en')}}</strong> children are associated with a school, <i class="fa fa-bolt"></i> <strong>{{ readersInOrgs.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
      <div class="dashbox-cell">
        <flip-card id="db-readers-not-in-school">
          <dash-box slot="front" title="Readers not in School" :value="readersNotInOrgs.total" :active_value="readersNotInOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{readersNotInOrgs.total.toLocaleString('en')}}</strong> children are <strong><u>not</u></strong> associated with a school, <i class="fa fa-bolt"></i> <strong>{{ readersNotInOrgs.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;display:flex;align-items:flex-end;">
          Partners
          <label class="referred-toggle">
              <input type="checkbox" v-model="referredOnly"> Referred only
            </label>
            <router-link :to="`/challenges/${challenge}/partners/new`" class="btn btn-xs btn-link ml-auto">
              <i class="fa fa-plus" style="font-size:0.9em;margin-right:4px;"></i>Add Partner
            </router-link>
        </h2>

        <table class="table table-striped table-hover table-condensed" style="background:white;box-shadow: 2px 2px 3px 0px #c7d5e6;">
          <thead>
            <tr><th>Partner</th><th>Schools</th><th>Parents</th></tr>
          </thead>
          <tbody>
            <template v-for="group in partnersByCategory">
              <tr :key="'cat-'+group.category" class="category-heading" @click="toggleCategory(group.category)">
                <td colspan="3">
                  <i class="fa" :class="isCategoryCollapsed(group.category) ? 'fa-caret-right' : 'fa-caret-down'"></i>
                  {{ group.label }}
                  <span class="text-muted">({{ group.count }})</span>
                </td>
              </tr>
              <template v-for="p in (isCategoryCollapsed(group.category) ? [] : group.partners)">
                <template v-if="p.children && p.children.length > 0">
                  <tr :key="'heading-'+p.id" class="active">
                    <td colspan="3"><strong><router-link :to="`/challenges/${challenge}/partners/${p.slug}`">{{ p.name }}</router-link></strong></td>
                  </tr>
                  <tr v-for="child in p.children" :key="'child-'+child.id">
                    <td style="padding-left:20px;"><router-link :to="`/challenges/${challenge}/partners/${child.slug}`">{{ child.name }}</router-link></td>
                    <td>
                      <span
                        :class="{ 'referral-clickable': linkCount(child, 'organisations') > 0 }"
                        v-tooltip="linkCount(child, 'organisations') > 0 ? 'Click to view these schools' : ''"
                        @click.stop="linkCount(child, 'organisations') > 0 && setSchoolFilter({ type: 'partner', partnerId: child.id, referredOnly: referredOnly, label: child.name })"
                      >{{ linkCount(child, 'organisations') }}</span>
                    </td>
                    <td>{{ linkCount(child, 'users') }}</td>
                  </tr>
                </template>
                <tr v-else :key="p.id">
                  <td><router-link :to="`/challenges/${challenge}/partners/${p.slug}`">{{ p.name }}</router-link></td>
                  <td>
                    <span
                      :class="{ 'referral-clickable': linkCount(p, 'organisations') > 0 }"
                      v-tooltip="linkCount(p, 'organisations') > 0 ? 'Click to view these schools' : ''"
                      @click.stop="linkCount(p, 'organisations') > 0 && setSchoolFilter({ type: 'partner', partnerId: p.id, referredOnly: referredOnly, label: p.name })"
                    >{{ linkCount(p, 'organisations') }}</span>
                  </td>
                  <td>{{ linkCount(p, 'users') }}</td>
                </tr>
              </template>
            </template>
            <tr v-if="partners.length === 0">
              <td colspan="3" class="text-muted text-center">No partners yet</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-6">
        <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;display:flex;align-items:flex-end;">
          Non-Partner Referrals
          <button type="button" class="btn btn-xs btn-link ml-auto" @click="showLinkBuilder = true">
            <i class="fa fa-link" style="font-size:0.9em;margin-right:4px;"></i>Build a tracking link
          </button>
        </h2>

        <table class="table table-striped table-hover table-condensed" style="background:white;box-shadow: 2px 2px 3px 0px #c7d5e6;">
          <thead>
            <tr>
              <th>Source / Medium / Content</th>
              <th style="text-align:right;">Schools</th>
              <th style="text-align:right;">Parents</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(source, si) in nonPartnerReferrals">
              <tr
                :key="'src-'+si"
                class="referral-source-heading"
                :class="{ 'referral-muted': isUnknownLabel(source.source) }"
                @click="toggleSource(si)"
              >
                <td>
                  <i class="fa" :class="isSourceCollapsed(si) ? 'fa-caret-right' : 'fa-caret-down'"></i>
                  {{ sourceLabel(source.source) }}
                </td>
                <td style="text-align:right;">
                  <span
                    :class="{ 'referral-clickable': source.schools > 0 }"
                    v-tooltip="source.schools > 0 ? 'Click to view these schools' : ''"
                    @click.stop="source.schools > 0 && setSchoolFilter({ type: 'utm', source: normaliseUtm(source.source) })"
                  >{{ source.schools }}</span>
                </td>
                <td style="text-align:right;">{{ source.parents }}</td>
              </tr>
              <template v-for="(medium, mi) in (isSourceCollapsed(si) ? [] : source.mediums)">
                <tr
                  :key="'src-'+si+'-med-'+mi"
                  class="referral-medium-row"
                  :class="{ 'referral-medium-clickable': medium.contents && medium.contents.length > 0, 'referral-muted': isUnknownLabel(medium.medium) }"
                  @click="medium.contents && medium.contents.length > 0 ? toggleMedium(si, mi) : null"
                >
                  <td style="padding-left:20px;">
                    <i
                      v-if="medium.contents && medium.contents.length > 0"
                      class="fa"
                      :class="isMediumCollapsed(si, mi) ? 'fa-caret-right' : 'fa-caret-down'"
                    ></i>
                    <span v-else class="referral-caret-spacer"></span>
                    {{ medium.medium || 'Unknown medium' }}
                    <span
                      v-if="isDirtyLabel(medium.medium)"
                      class="text-muted"
                      style="font-size:0.85em;"
                      title="from a malformed tracking link"
                    >(malformed link)</span>
                  </td>
                  <td style="text-align:right;">
                    <span
                      :class="{ 'referral-clickable': medium.schools > 0 }"
                      v-tooltip="medium.schools > 0 ? 'Click to view these schools' : ''"
                      @click.stop="medium.schools > 0 && setSchoolFilter({ type: 'utm', source: normaliseUtm(source.source), medium: normaliseUtm(medium.medium) })"
                    >{{ medium.schools }}</span>
                  </td>
                  <td style="text-align:right;">{{ medium.parents }}</td>
                </tr>
                <tr
                  v-for="(content, ci) in (isMediumCollapsed(si, mi) ? [] : medium.contents)"
                  :key="'src-'+si+'-med-'+mi+'-con-'+ci"
                  class="referral-content-row"
                  :class="{ 'referral-muted': content.content === null || isUnknownLabel(content.content) }"
                >
                  <td style="padding-left:40px;">
                    {{ content.content === null ? 'No specific content' : content.content }}
                    <span
                      v-if="isDirtyLabel(content.content)"
                      class="text-muted"
                      style="font-size:0.85em;"
                      title="from a malformed tracking link"
                    >(malformed link)</span>
                  </td>
                  <td style="text-align:right;">
                    <span
                      :class="{ 'referral-clickable': content.schools > 0 }"
                      v-tooltip="content.schools > 0 ? 'Click to view these schools' : ''"
                      @click.stop="content.schools > 0 && setSchoolFilter({ type: 'utm', source: normaliseUtm(source.source), medium: normaliseUtm(medium.medium), content: normaliseUtm(content.content), contentIsRemainder: content.content === null })"
                    >{{ content.schools }}</span>
                  </td>
                  <td style="text-align:right;">{{ content.parents }}</td>
                </tr>
              </template>
            </template>
            <tr v-if="nonPartnerReferrals.length === 0">
              <td colspan="3" class="text-muted text-center">No non-partner referrals yet</td>
            </tr>
          </tbody>
        </table>

        <div>
        <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;margin-top:30px;">Regional Breakdown</h2>
          <table class="table table-striped table-hover table-condensed" style="background:white; box-shadow: 2px 2px 3px 0px #c7d5e6;">
            <thead>
              <tr><th>Region</th><th>Schools</th><th>Parents</th><th>Readers</th></tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in regions" :key="i">
                <td>{{ r || 'Unknown Region' }}</td>
                <td>
                  <span
                    :class="{ 'referral-clickable': (regionSchoolCounts[r] || 0) > 0 }"
                    v-tooltip="(regionSchoolCounts[r] || 0) > 0 ? 'Click to view these schools' : ''"
                    @click.stop="(regionSchoolCounts[r] || 0) > 0 && setSchoolFilter({ type: 'region', region: r, label: r || 'Unknown Region' })"
                  >{{ regionSchoolCounts[r] || 0 }}</span>
                </td>
                <td>{{ totalUsers.regional[r] ? totalUsers.regional[r].total : 0 }}</td>
                <td>{{ totalReaders.regional[r] ? totalReaders.regional[r].total : 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Certificates & Stars</h2>
          <table class="table table-striped table-hover table-condensed" style="background:white; box-shadow: 2px 2px 3px 0px #c7d5e6;">
            <thead>
              <tr><th></th><th>Awarded</th></tr>
            </thead>
            <tbody>
              <tr v-for="(c, i) in certificates" :key="i">
                <td v-tooltip="{content:c.description, placement: 'auto-start'}">{{ c.name }}</td>
                <td>{{ c.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row" ref="schoolsTable">
      <div class="col-12">
        <div class="report-header">
          <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Schools</h2>
        </div>
        <div v-if="schoolFilter" class="school-filter-banner">
          <span>{{ schoolFilter.type === 'region' ? 'Showing schools in' : 'Showing schools referred by' }} <strong>{{ schoolFilter.label }}</strong></span>
          <button type="button" class="btn btn-xs btn-link" @click="clearSchoolFilter">Clear filter</button>
        </div>
      </div>
      <div class="col-md-12">
        <vue-good-table
          ref="schoolsGrid"
          styleClass="vgt-table striped"
          theme="auris-admin"
          :columns="columns"
          :rows="filteredSchools"
          :totalRows="filteredSchools.length"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 25,
            position: 'bottom',
            perPageDropdown: [10, 25, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'name', type: 'asc'}
          }"
          >
           <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'name'">
              <a :href="`/challenges/${challenge}/organisations/${props.row.id}`">{{props.row.name}}</a>
            </span>
            <span v-else-if="props.column.field === 'rank'">
              {{ props.row.rank === null ? '-' : numberRank(props.row.rank) }}
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <utm-link-builder
      v-if="showLinkBuilder"
      :challenge-slug="challenge"
      :domain="challengeDomain"
      @close="showLinkBuilder = false"
    />
  </div>
  </wrapper>
</template>
<script>
import Wrapper from '@/components/Wrapper';
import { VueGoodTable } from 'vue-good-table';
import DashBox from '@/components/DashBox';
import moment from 'moment';
import FlipCard from '@/components/FlipCard';
import VTooltip from 'v-tooltip';
import UtmLinkBuilder from '@/components/challenges/UtmLinkBuilder';
import EDUCATION_PHASES from '@/config/educationPhases';

const transformHeader = (s) => s.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()).replace(/[-_]+(.)/g, (_, c) => ` ${c.toUpperCase()}`);

// Mirror of the API ChallengeReferralSource::normaliseUtmValue - both sides must
// bucket identically so a clicked count matches the filtered row count.
const normaliseUtm = (v) => {
  if (typeof v !== 'string') return null;
  const t = v.trim();
  return t === '' ? null : t;
};

// vue-good-table's number sort treats null as -Infinity, which ranks unranked
// schools above 1st place. Rank is better-when-lower, so an absent rank is the
// worst rank, not the best.
const rankSort = (x, y) => {
  if (x === y) return 0;
  if (x === null) return 1;
  if (y === null) return -1;
  return x - y;
};

const secondsToString = (seconds = 0) => {
  if (seconds < 60) {
    return `${seconds} ${seconds === 1 ? 'sec' : 'secs'}`;
  }
  const hours = Math.floor(seconds / 3600);
  const totalSeconds = seconds % 3600;
  const minutes = Math.floor(totalSeconds / 60);
  let string = '';
  if (hours >= 1) {
    string += `${hours} ${hours === 1 ? 'hr ' : 'hrs '}`;
  }
  if (minutes >= 1) {
    string += `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
  }

  return string.trim();
};

class ReportItem {
  constructor(item) {
    this.id = item.id || null;
    this.name = item.name || '';
    this.code = item.code || '';
    this.contact_name = item.contact_name || '';
    this.contact_email = item.contact_email || '';
    this.contact_job_role = item.contact_job_role || '';
    this.school_type = item.school_type ? item.school_type.toUpperCase() : '';
    this.education_phase = EDUCATION_PHASES[item.education_phase] || '';
    this.governed_by = item.school_governed_by_name || '';
    this.city = item.city || '';
    this.region = item.region || '';
    this.postcode = item.postcode || '';
    this.registered_on = item.created_at || '';
    // vue-good-table's date column errors on an empty string ("Not a valid
    // date"); use null so it renders blank instead of trying to parse it.
    this.last_pupil_activity = item.last_pupil_activity || null;
    this.total_readers = item.total_readers || 0;
    this.active_readers = item.total_active_readers || 0;
    this.recently_active_readers = item.total_recent_active_readers || 0;
    this.stars = 0;
    this.books_read = 0;
    this.reading_time_seconds = 0;
    // Null rather than 0: a school off the leaderboard is unranked, not last.
    this.rank = null;
    this.score = null;
    if (item.leaderboard) {
      this.stars = item.leaderboard.total_stars || 0;
      this.books_read = item.leaderboard.total_books || 0;
      this.reading_time_seconds = item.leaderboard.total_reading_time || 0;
      this.rank = item.leaderboard.rank ?? null;
      this.score = item.leaderboard.score ?? null;
    }
    switch (this.school_type) {
      case 'MAT':
        this.school_type = 'Multi-Academy Trust';
        break;
      case 'LA':
        this.school_type = 'Local Authority';
        break;
      default:
        this.school_type = '';
        break;
    }
    this.referral = item.referral || { utm_source: null, utm_medium: null, utm_content: null };
    this.partner_links = item.partner_links || [];
  }
}

export default {
  components: {
    Wrapper,
    VueGoodTable,
    DashBox,
    FlipCard,
    VTooltip, // eslint-disable-line
    UtmLinkBuilder,
  },
  data() {
    return {
      columns: [
        {
          label: 'Rank',
          field: 'rank',
          type: 'number',
          sortFn: rankSort,
        },
        {
          label: 'Name',
          field: 'name',
          sortable: true,
        },
        {
          label: 'School Type',
          field: 'school_type',
          sortable: false,

        },
        {
          label: 'Governed by',
          field: 'governed_by',
        },
        {
          label: 'Registered On',
          field: 'registered_on',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'do MMMM yy @ hh:mm a',
        },
        {
          label: 'Total Readers',
          field: 'total_readers',
          type: 'number',
        },
        {
          label: 'Active Readers',
          field: 'active_readers',
          type: 'number',
        },
        {
          label: 'Score',
          field: 'score',
          type: 'number',
          formatFn: (score) => (score === null ? '-' : score),
        },
        {
          label: 'Stars',
          field: 'stars',
          type: 'number',
        },
        {
          label: 'Books',
          field: 'books_read',
          type: 'number',
        },
        {
          label: 'Reading Time',
          field: 'reading_time_seconds',
          formatFn: (seconds) => secondsToString(seconds),
          type: 'number',
        },
        {
          label: 'Last Pupil Activity',
          field: 'last_pupil_activity',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'do MMMM yy @ hh:mm a',
        },
      ],
      data: [],
      readersInOrgs: { total: 0, active: 0 },
      totalReaders: { total: 0, active: 0 },
      totalUsers: { total: 0, active: 0 },
      gettingCSV: false,
      isLoading: false,
      isExporting: false,
      partners: [],
      regions: [],
      certificates: [],
      collapsedCategories: {},
      referredOnly: false,
      nonPartnerReferrals: [],
      collapsedSources: {},
      collapsedMediums: {},
      showLinkBuilder: false,
      schoolFilter: null,
    };
  },
  computed: {
    challenge() {
      return this.$route.params.challengeSlug;
    },
    challengeDomain() {
      const challenges = this.$store.state.challenges.challenges || [];
      const match = challenges.find((c) => c.slug === this.challenge);
      return match ? match.domain || null : null;
    },
    partnersByCategory() {
      const labels = {
        general: 'General',
        costa: 'Costa',
        english_hub: 'English Hub',
      };
      const order = ['general', 'costa', 'english_hub'];
      const byName = (a, b) => a.name.localeCompare(b.name);
      const roots = this.partners.filter((p) => p.parent_id === null);
      const groups = {};
      roots.forEach((p) => {
        const cat = p.category || 'general';
        if (!groups[cat]) groups[cat] = [];
        const sortedChildren = p.children ? [...p.children].sort(byName) : p.children;
        groups[cat].push({ ...p, children: sortedChildren });
      });
      const knownOrder = order.filter((c) => groups[c]);
      const extras = Object.keys(groups).filter((c) => !order.includes(c)).sort();
      return [...knownOrder, ...extras].map((category) => {
        const partners = groups[category];
        const count = partners.reduce(
          (n, p) => n + 1 + (p.children ? p.children.length : 0),
          0,
        );
        return {
          category,
          label: labels[category] || category,
          partners,
          count,
        };
      });
    },
    totalOrgs() {
      return {
        total: this.data.length,
        active: this.data.filter((s) => s.active_readers > 0).length,
      };
    },
    readersNotInOrgs() {
      return {
        total: this.totalReaders.total - this.readersInOrgs.total,
        active: this.totalReaders.active - this.readersInOrgs.active,
      };
    },
    // Computed (not a method) so the per-row region count is cached, rather than
    // re-filtering this.data on every re-render.
    regionSchoolCounts() {
      const counts = {};
      this.data.forEach((s) => {
        counts[s.region] = (counts[s.region] || 0) + 1;
      });
      return counts;
    },
    // partner_id -> name, including children, for resolving partner_links.
    partnerNameById() {
      const map = {};
      const add = (p) => {
        if (!p) return;
        map[p.id] = p.name;
        (p.children || []).forEach(add);
      };
      this.partners.forEach(add);
      return map;
    },
    filteredSchools() {
      if (!this.schoolFilter) return this.data;
      const f = this.schoolFilter;
      if (f.type === 'partner') {
        return this.data.filter((s) => (s.partner_links || []).some(
          (l) => l.partner_id === f.partnerId && (!f.referredOnly || l.is_referral),
        ));
      }
      if (f.type === 'region') {
        // Mirror orgRegionStats: a school's region is '' when unknown, which the
        // regional table groups under the same key, so match on the raw value.
        return this.data.filter((s) => s.region === f.region);
      }
      // utm: f.source/f.medium/f.content are already-normalised values (or null
      // for the unknown bucket). `undefined` means that depth is not part of the
      // filter.
      return this.data.filter((s) => {
        const r = s.referral || {};
        if (normaliseUtm(r.utm_source) !== f.source) return false;
        if (f.medium === undefined) return true;
        if (normaliseUtm(r.utm_medium) !== f.medium) return false;
        if (f.content === undefined) return true;
        if (f.contentIsRemainder) return normaliseUtm(r.utm_content) === null;
        return normaliseUtm(r.utm_content) === f.content;
      });
    },
  },
  methods: {
    refreshData() {
      this.isLoading = true;
      this.$store.dispatch('reports/getChallengesReport', this.challenge).then((response) => {
        const { data } = response;
        this.data = data.challenge_organisations.map((item) => new ReportItem(item));
        this.readersInOrgs = data.total_challenge_organisation_readers;
        this.totalReaders = data.total_challenge_readers;
        this.totalUsers = data.total_challenge_users;
        this.certificates = data.challenge_certificates;
        this.nonPartnerReferrals = data.challenge_non_partner_referrals || [];
        // Collapse state is keyed by row index, so a refresh that reorders or
        // changes the referral rows (e.g. switching challenge) would leave the
        // flags pointing at different rows. Reset them with the fresh data.
        this.collapsedSources = {};
        this.collapsedMediums = {};
        this.schoolFilter = null;
        this.regions = Array.from(new Set([
          ...Object.keys(this.totalUsers.regional),
          ...Object.keys(this.totalReaders.regional),
          ...this.data.map((s) => s.region),
        ])).sort();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    fetchPartners() {
      this.$store.dispatch('challenges/getChallengePartners', this.challenge).then((partners) => {
        this.partners = partners;
      }).catch((err) => {
        this.$apiResponse.renderErrorMessage(err);
      });
    },
    linkCount(partner, type) {
      if (!partner.link_counts) return 0;
      const key = this.referredOnly ? `${type}_referred` : type;
      return partner.link_counts[key] || 0;
    },
    isCategoryCollapsed(category) {
      if (Object.prototype.hasOwnProperty.call(this.collapsedCategories, category)) {
        return this.collapsedCategories[category];
      }
      return category !== 'general';
    },
    toggleCategory(category) {
      this.$set(this.collapsedCategories, category, !this.isCategoryCollapsed(category));
    },
    sourceLabel(source) {
      return source || 'Unknown source';
    },
    isUnknownLabel(label) {
      if (label === null || label === undefined || label === '') return true;
      return /^#REF!?$/i.test(label);
    },
    isDirtyLabel(label) {
      if (label === null || label === undefined || label === '') return false;
      return /^#REF!?$/i.test(label);
    },
    isSourceCollapsed(key) {
      if (Object.prototype.hasOwnProperty.call(this.collapsedSources, key)) {
        return this.collapsedSources[key];
      }
      return true;
    },
    toggleSource(key) {
      this.$set(this.collapsedSources, key, !this.isSourceCollapsed(key));
    },
    isMediumCollapsed(si, mi) {
      const key = `${si}-${mi}`;
      if (Object.prototype.hasOwnProperty.call(this.collapsedMediums, key)) {
        return this.collapsedMediums[key];
      }
      return true;
    },
    toggleMedium(si, mi) {
      const key = `${si}-${mi}`;
      this.$set(this.collapsedMediums, key, !this.isMediumCollapsed(si, mi));
    },
    normaliseUtm(v) {
      return normaliseUtm(v);
    },
    buildUtmLabel({
      source, medium, content, contentIsRemainder,
    }) {
      const parts = [source === null || source === undefined ? 'Unknown source' : source];
      if (medium !== undefined) parts.push(medium === null ? 'Unknown medium' : medium);
      if (content !== undefined) parts.push(contentIsRemainder ? 'No specific content' : content);
      return parts.join(' / ');
    },
    setSchoolFilter(filter) {
      const resolved = { ...filter };
      if (resolved.type === 'utm' && !resolved.label) {
        resolved.label = this.buildUtmLabel(resolved);
      }
      this.schoolFilter = resolved;
      this.$nextTick(() => {
        this.resetSchoolsPage();
        if (this.$refs.schoolsTable) {
          this.$refs.schoolsTable.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    clearSchoolFilter() {
      this.schoolFilter = null;
      this.$nextTick(this.resetSchoolsPage);
    },
    // The table clamps its own row slice on filter, but the pagination footer
    // keeps its stale page number; changePage(1) resyncs both.
    resetSchoolsPage() {
      if (this.$refs.schoolsGrid) {
        this.$refs.schoolsGrid.changePage(1);
      }
    },
    schoolPartnerNames(row) {
      return (row.partner_links || [])
        .map((l) => this.partnerNameById[l.partner_id])
        .filter(Boolean)
        .join(';');
    },
    // Partner name(s) if linked, else the UTM source/medium/content trail.
    schoolReferredBy(row) {
      const partners = this.schoolPartnerNames(row);
      if (partners) return partners;
      const r = row.referral || {};
      const utm = [r.utm_source, r.utm_medium, r.utm_content]
        .map(normaliseUtm)
        .filter((v) => v !== null);
      return utm.join(' / ');
    },
    getSchoolsCSV() {
      const items = this.data;
      if (!items.length) return;
      // referral/partner_links are objects/arrays; JSON.stringify-ing them inline
      // would inject commas that break the CSV, so render them as the two columns
      // below instead.
      const skip = ['referral', 'partner_links'];
      const fields = Object.keys(items[0]).filter((key) => !skip.includes(key));
      const header = [...fields.map(transformHeader), 'Partners', 'Referred By'];
      const csv = [
        header.join(','),
        ...items.map((row) => [
          ...fields.map((fieldName) => JSON.stringify(row[fieldName])),
          JSON.stringify(this.schoolPartnerNames(row)),
          JSON.stringify(this.schoolReferredBy(row)),
        ].join(',')),
      ].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `challenges_report${moment().format('DD/MM/YYYY')}.csv`);
        link.style = 'visibility:hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getReadersCSV() {
      this.isExporting = true;
      this.$store.dispatch('challenges/exportReadersCsv', this.challenge).then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.challenge} readers list.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }).finally(() => {
        this.isExporting = false;
      });
    },
    numberRank(n) {
      const s = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
  },
  watch: {
    '$route.params.challengeSlug': function watchChallenge() {
      this.refreshData();
      this.fetchPartners();
    },
  },
  mounted() {
    this.refreshData();
    this.fetchPartners();
    const challenges = this.$store.state.challenges.challenges || [];
    if (challenges.length === 0) {
      this.$store.dispatch('challenges/getChallenges');
    }
  },
};
</script>
<style lang="scss" scoped>
// Equal-width dashboxes. Not a 12-column layout, so use CSS grid rather than the
// Bootstrap grid: auto-fill packs as many >=250px columns as fit and keeps every
// box the same width across all rows (a flex strip would stretch a short last row
// wider than the others). Boxes wrap onto new rows instead of overflowing and
// overlapping.
.dashbox-strip {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.referred-toggle {
  font-size: 1.2rem;
  font-weight: 400;
  margin-left: 2em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.referred-toggle input {
  margin: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.category-heading {
  cursor: pointer;
  user-select: none;
}
.category-heading td {
  background: #e9eef4;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85em;
  letter-spacing: 0.05em;
  color: #224450;
}
.category-heading:hover td {
  background: #dde5ef;
}
.category-heading .fa {
  width: 12px;
  margin-right: 4px;
}
.referral-source-heading {
  cursor: pointer;
  user-select: none;
}
.referral-source-heading .fa {
  width: 12px;
  margin-right: 4px;
}
.referral-medium-clickable {
  cursor: pointer;
  user-select: none;
}
.referral-medium-row .fa {
  width: 12px;
  margin-right: 4px;
}
.referral-caret-spacer {
  display: inline-block;
  width: 12px;
  margin-right: 4px;
}
.referral-content-row td {
  color: #6c7a89;
}
.referral-muted td {
  color: #98a3ac;
  font-style: italic;
}
.referral-clickable {
  cursor: pointer;
  color: #337ab7;
}
.referral-clickable:hover {
  text-decoration: underline;
}
.school-filter-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 15px 10px;
  padding: 8px 12px;
  background: #f4f8fb;
  border-left: 4px solid #337ab7;
  color: #224450;
}
</style>
